import { useMemo, useState } from "react";

export const SignatureProfileGallery = ({ profile }: { profile: any }) => {
  const products = useMemo(
    () => (Array.isArray(profile?.products) ? profile.products : []),
    [profile?.products]
  );

  const categories = useMemo(() => {
    const unique: string[] = [];

    products.forEach((p: any) => {
      const category = p?.categoryName;

      if (category && !unique.includes(category)) unique.push(category);
    });

    return unique;
  }, [products]);

  const [selectedCategory, setSelectedCategory] = useState<string>("all");

  const filteredProducts = useMemo(() => {
    if (selectedCategory === "all") {
      return products;
    }

    return products.filter((p: any) => p?.categoryName === selectedCategory);
  }, [products, selectedCategory]);

  const leadContent: string | undefined = profile?.leadContent;
  const hasProducts = products.length > 0;

  if (!hasProducts) return null;

  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8">
          <div>
            <h2 className="font-playfair text-3xl font-bold mb-2">
              Portfolio Gallery
            </h2>
            {/* 11. Signature Profile portfolio gallery lead_content */}
            {leadContent ? (
              <p className="text-muted-foreground">{leadContent}</p>
            ) : null}
          </div>
          {categories.length > 0 ? (
            <div className="ml-2 mt-4 md:mt-0 flex items-center gap-2">
              {/* 12. Signature Profile portfolio gallery filter button (filter by signature profile product categories) */}
              <div className="flex gap-2">
                <button
                  className={`inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-9 px-3 rounded-full capitalize ${
                    selectedCategory === "all"
                      ? "bg-primary text-primary-foreground hover:bg-primary/90"
                      : "border border-input bg-background hover:bg-accent hover:text-accent-foreground"
                  }`}
                  onClick={() => setSelectedCategory("all")}
                  type="button"
                >
                  all
                </button>
                {categories.map((category) => (
                  <button
                    key={category}
                    className={`inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-9 px-3 rounded-full capitalize ${
                      selectedCategory === category
                        ? "bg-primary text-primary-foreground hover:bg-primary/90"
                        : "border border-input bg-background hover:bg-accent hover:text-accent-foreground"
                    }`}
                    onClick={() => setSelectedCategory(category)}
                    type="button"
                  >
                    {category}
                  </button>
                ))}
              </div>
            </div>
          ) : null}
        </div>
        {/* 13. Signature Profile portfolio gallery images (signature_profile.products) */}
        {filteredProducts.length > 0 ? (
          <div className="gallery-masonry">
            {filteredProducts.map((product: any) =>
              product?.pictureLargeUrl ? (
                <div className="artwork-card " key={product.id}>
                  <a
                    href={product.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block"
                  >
                    <img
                      src={product.pictureLargeUrl}
                      alt={product?.name || "Artwork"}
                      className="w-full h-auto hover:opacity-90 transition-opacity cursor-pointer"
                    />
                  </a>
                </div>
              ) : null
            )}
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default SignatureProfileGallery;
